import { ActiveInteractionChangedEventData } from './active-interaction-changed-event-data';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class ActiveInteractionChangedMapEvent implements MapEvent {
    type = MapEventType.activeInteractionChanged;
    constructor(public payload: ActiveInteractionChangedEventData) {}
}
